import {Injectable} from "@angular/core";
import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {GetCurrentDeliveryPointUseCase} from "@app/core/delivery-point/application/get-current-delivery-point.use-case";
import {GetIsMobileUseCase} from "@app/core/shared/application/get-is-mobile.use-case";
import {GetVersionNumberUseCase} from "@app/core/shared/application/get-version-number.use-case";
import {DeleteAccountUseCase} from "@app/core/user/application/delete-account.use-case";
import {GetUserUseCase} from "@app/core/user/application/get-user.usecase";
import {IsLoggedInUseCase} from "@app/core/user/application/isLoggedIn.use-case";
import {LogoutUseCase} from "@app/core/user/application/logout.use-case";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {Observable, Subscriber} from "rxjs";
import {take} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class AccountViewModel {

    public notifier = new PopupNotifier();
    private logoutSucceedEmitter!: Subscriber<void>;
    private deleteAccountSucceedEmitter!: Subscriber<void>;
    public logoutSucceed$: Observable<void> = new Observable<void>(emitter => this.logoutSucceedEmitter = emitter);
    public deleteAccountSucceed$: Observable<void> = new Observable<void>(emitter => this.deleteAccountSucceedEmitter = emitter);

    constructor(
        private getUserUseCase: GetUserUseCase,
        private getIsMobileUseCase: GetIsMobileUseCase,
        private getVersionNumberUseCase: GetVersionNumberUseCase,
        private isLoggedInUseCase: IsLoggedInUseCase,
        private logoutUseCase: LogoutUseCase,
        private deleteAccountUseCase: DeleteAccountUseCase,
        private getCurrentDeliveryPointUseCase: GetCurrentDeliveryPointUseCase
    ) { }

    getUser() {
        return this.getUserUseCase.execute();
    }

    getIsMobile(): boolean {
        return this.getIsMobileUseCase.execute();
    }

    getVersionNumber(): Observable<string> {
        return this.getVersionNumberUseCase.execute();
    }

    getIsLoggedIn(): Observable<boolean> {
        return this.isLoggedInUseCase.execute()
    }

    getCurrentDeliveryPoint(): Observable<DeliveryPoint | null> {
        return this.getCurrentDeliveryPointUseCase.execute();
    }

    logout(): void {
        this.logoutUseCase.execute().subscribe({
            next: () => {
                this.logoutSucceedEmitter.next();
            },
            error: error => {
                this.notifier.notifyError(error);
            }
        });
    }

    deleteAccount(): void {
        this.deleteAccountUseCase.execute()
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this.deleteAccountSucceedEmitter.next();
                },
                error: error => {
                    this.notifier.notifyError(error);
                }
            });
    }

}
